// * GET =====================================

// * PATCH ===================================
export const WORKSPACE_PATCH = (workspaceId: string) =>
  `/workspace/${workspaceId}`;

// * POST ====================================

// * DELETE ==================================
export const WORKSPACE_DELETE = (workspaceId: string) =>
  `/workspace/${workspaceId}`;

// * PUT =====================================
export const WORKSPACE_PUT = `/workspace`;
